module.exports = __webpack_public_path__ + "static/img/brees-2004-slide-4.caf1075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-slide-4.jpg
// module id = QnVw
// module chunks = 1